export default "__VITE_ASSET__C1A86YCC__"